/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClinicBookingInfo } from './ClinicBookingInfo';
import {
    ClinicBookingInfoFromJSON,
    ClinicBookingInfoFromJSONTyped,
    ClinicBookingInfoToJSON,
} from './ClinicBookingInfo';

/**
 * 
 * @export
 * @interface ClinicBookingControllerGetBookings200Response
 */
export interface ClinicBookingControllerGetBookings200Response {
    /**
     * 
     * @type {number}
     * @memberof ClinicBookingControllerGetBookings200Response
     */
    count: number;
    /**
     * 
     * @type {Array<ClinicBookingInfo>}
     * @memberof ClinicBookingControllerGetBookings200Response
     */
    data: Array<ClinicBookingInfo>;
}

/**
 * Check if a given object implements the ClinicBookingControllerGetBookings200Response interface.
 */
export function instanceOfClinicBookingControllerGetBookings200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ClinicBookingControllerGetBookings200ResponseFromJSON(json: any): ClinicBookingControllerGetBookings200Response {
    return ClinicBookingControllerGetBookings200ResponseFromJSONTyped(json, false);
}

export function ClinicBookingControllerGetBookings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicBookingControllerGetBookings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'data': ((json['data'] as Array<any>).map(ClinicBookingInfoFromJSON)),
    };
}

export function ClinicBookingControllerGetBookings200ResponseToJSON(value?: ClinicBookingControllerGetBookings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'data': ((value.data as Array<any>).map(ClinicBookingInfoToJSON)),
    };
}

